// Redux slice quản lý hàng hóa
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { toast } from "react-toastify";

export const fetchHangHoa = createAsyncThunk("hangHoa/fetchHangHoa", async (params = {}, { rejectWithValue }) => {
  try {
    const query = {
      size: params.size || 10,
      order: "id desc",
      page: params.page || 1,
      search: params.search,
      type: "consu", // Chỉ lấy hang hóa loại "item"
    };

    // chỉ thêm nếu active có giá trị khác ""
    if (params.active !== "") {
      query.active = params.active;
    }
    const res = await api.get("/product.product", { params: query });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const addHangHoa = createAsyncThunk("hangHoa/addHangHoa", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.post("/product.product", { ...payload, type: "consu", is_storable: true });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateHangHoa = createAsyncThunk("hangHoa/updateHangHoa", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put(`/product.product/${payload.id}`, payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const deleteHangHoa = createAsyncThunk("hangHoa/deleteHangHoa", async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/product.product/${id}`);
    toast.success("Xóa hàng hóa thành công!");
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
const initialData = {
  items: { content: [], totalElements: 0 },
};
const hangHoaSlice = createSlice({
  name: "hangHoa",
  initialState: initialData,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHangHoa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHangHoa.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchHangHoa.rejected, (state) => {
        state.loading = false;
        // state.error = action.payload;
      })
      .addCase(addHangHoa.fulfilled, (state, action) => {
        state.items?.content?.push(action.payload);
        state.items.totalElements += 1;
      })
      .addCase(updateHangHoa.fulfilled, (state, action) => {
        const idx = state.items?.content?.findIndex((d) => d.id === action.payload.id);
        if (idx > -1) state.items[idx] = { ...state.items.content[idx], ...action.payload };
      })
      .addCase(deleteHangHoa.fulfilled, (state, action) => {
        state.items.content = state.items.content?.filter((d) => d.id !== action.payload);
        state.items.totalElements -= 1;
      });
  },
});

export default hangHoaSlice.reducer;
